<ng-container *transloco="let translate">
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <h1 class="text-xl font-semibold" [textContent]="translate('Pre-Captured Attributes')"></h1>
        <material-button class="p-2 rounded-full" [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" [classList]="['focus:!outline-none', 'hover:!bg-gray-100']" (buttonClicked)="closeModal()"></material-button>
    </div>
    <mat-dialog-content class="w-full h-[76%] overflow-auto px-4 py-2 relative !left-[15px]">
        <div class="pt-[20px] px-[40px] pb-0">
            <div class="m-0 p-[0_30px] relative min-h-[150px] row" *ngIf="preCapturedAttributes.length > 0">
                <ng-container *ngFor="let recordField of preCapturedAttributes">
                    <div class="flex-1 min-w-[33.33%] mt-[10px] max-w-[33.33%]" *ngIf="recordField.isPrecaptured">
                        <div>
                            <strong class="inline-block align-middle leading-[40px]" [textContent]="recordField.displayName"></strong>
                            <span class="inline-block align-middle leading-[24px] ml-[10px] rotate-45" *ngIf="recordField.isBusinessKey">vpn_key</span>
                        </div>
                        <ng-container *ngIf="recordField.value">
                            <div [title]="recordField.value" [textContent]="recordField.value !== undefined ? recordField.value : '--'"></div>
                        </ng-container>
                        <ng-container *ngIf="recordField.values && recordField.values.length > 0">
                            <div [title]="recordField.values.join(',')" [textContent]="recordField.values !== undefined ? recordField.values.join(',') : '--'"></div>
                        </ng-container>
                    </div>
                </ng-container>
            </div>
            <ng-container *ngIf="preCapturedAttributes.length === 0">
                <div class="w-full text-center">
                    <span [textContent]="translate('No precaptured attributes.')"></span>
                </div>
            </ng-container>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]">
        <material-button [text]="translate('Close')" (buttonClicked)="closeModal()"></material-button>
    </mat-dialog-actions>
</ng-container>
